









import VueOptions from '@utils/VueOptions'

settings =
  name: ""
  resources:
    organizer: 
      resourceName: "organizer"
      slug: "organizers/:organizerId"
  vue:
    props: ['organizerId']

export default VueOptions.vue settings

